import { useState } from 'react';

export const useDlqFileValidation = () => {
  const [file, setFile] = useState<File>();
  const [error, setError] = useState<string>("");
  const [messageCount, setMessageCount] = useState<number>(0);
  const [redriveOK, setRedriveOK] = useState<boolean>(false);

  const handleFileChange = (files: File[]) => {
    if (files.length > 0) {
      setFile(files[0]);
      setRedriveOK(false);
      setError("");
      setMessageCount(0);
    } else {
      setFile(undefined);
      setRedriveOK(true);
      setError("");
      setMessageCount(0);
    }
  };

  const validateFile = async (file: File) => {
    try {
      const text = await file.text();
      const lines = text.trim().split('\n');
      
      if (lines.length === 0) {
        setError("File is empty");
        return;
      }

      const headers = lines[0]
        .split(",")
        .map((h) => h.trim().replace(/^"|"$/g, ""));
      if (!headers.includes("dlq_pk")) {
        setError("File must have 'dlq_pk' as a CSV header");
        return;
      }

      const pks = lines.slice(1).filter(line => line.trim());
      setMessageCount(pks.length);
      setRedriveOK(true);
    } catch (err) {
      setError(`Failed to read file: ${err instanceof Error ? err.message : String(err)}`);
    }
  };

  const validateRedrive = () => {
    if (file) {
      validateFile(file);
    }
  };

  return {
    file,
    messageCount,
    error,
    redriveOK,
    handleFileChange,
    validateRedrive,
  };
};
